import React, { Component } from 'react'

export default class MapSection extends Component{
  render(){
  	const {children} = this.props
	  return(
	  	<div className="hud-map__pointers">
			{ children }
	  	</div>
	  )
  }
}
